import {Component} from '@angular/core';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-add-instructor-support-article',
    template: `
        <ng-container i18n="@@support.articles.addInstructor">
            <ol>
                <li>
                    <span>Go to the <a routerLink="/organization/instructors">Instructors Overview</a>.</span>
                </li>
                <li>
                    <span>Click the <strong>Add a new instructor</strong> button.</span>
                </li>
                <li>
                    <div>
                        Fill in the form.<br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/addInstructor.png" />

                        <ul>
                            <li>
                                The instructor's <strong>first name</strong>
                            </li>
                            <li>
                                The instructor's <strong>name</strong>
                            </li>
                            <li>
                                <strong>E-mail:</strong> this is where the login details will be sent.
                            </li>
                            <li>
                                <strong>Role:</strong> choose if it's an instructor or an administrator.
                                <p>
                                    <a
                                        routerLink="/support/organizations/instructors/instructor-administrator"
                                        mat-stroked-button
                                        color="primary"
                                        class="supportLink"
                                    >Instructor or administrator?</a>
                                </p>
                            </li>
                        </ul>
                    </div>
                </li>
                <li>
                    <span>Click <strong>Save</strong>.</span>
                </li>
                <li>
                    <span>The instructor will receive the <strong>login details by e-mail</strong> within 30 minutes. Didn't receive the e-mail? Check if the email ended up in the spam box!</span>
                </li>
            </ol>
        </ng-container>
    `
})
export class AddInstructorSupportArticleComponent {
    constructor(
        public languageService: LanguageService
    ) {}
}
